module.exports = __webpack_public_path__ + "static/media/xml.fb9ae02c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/xml.svg
// module id = 1677
// module chunks = 17